import { BUSINESS_LIMITS } from '../constants/limits';
/**
 * KATILIM BELGESİ VE ETKİNLİK SONRASI ANKET (kapsam 25.10.2026, Story 1).
 * Joi'siz değerler: API, web ve mobil aynı sözlüğü ve aynı eşik kuralını okur.
 *
 * Anket ANONİMDİR (kullanıcı kararı 25.10): organizatör yalnız toplu sonucu
 * görür. Cevap ile kullanıcı arasındaki bağ ayrı tabloda tutulur ve anket
 * kapanışından 30 gün sonra koparılır; puan ve seçim cevapları etkinlik
 * bitişinden 24 ay, serbest metin 12 ay sonra silinir.
 */
export const EVENT_SURVEY_STATUSES = ['draft', 'published', 'closed', 'disabled_by_staff'];
/**
 * Paneldeki anket hâli (Story 8, tasarım kare 11). Sunucuda tek kuraldan çıkar:
 * anket yoksa `none`, taslakta `draft`, yayında ve kapanış gelmediyse `open`,
 * kapandıysa `closed`, personel kapattıysa `disabled_by_staff`.
 */
export const PANEL_POST_EVENT_SURVEY_STATES = [
    'none',
    'draft',
    'open',
    'closed',
    'disabled_by_staff',
];
export const EVENT_SURVEY_QUESTION_KINDS = [
    'rating_5',
    'nps_10',
    'single_choice',
    'multi_choice',
    'short_text',
];
/** Tavsiye ölçeğinin (0-10) üç grubu, sonuç çubuklarının sırasıyla: 9-10, 7-8, 0-6. */
export const EVENT_SURVEY_NPS_GROUPS = ['promoters', 'passives', 'detractors'];
/** Hazır soruların anahtarı; metin i18n'den gelir (`eventSurvey.presets.<key>`). */
export const EVENT_SURVEY_PRESET_KEYS = [
    'overall_satisfaction',
    'recommend',
    'liked_most',
    'improve',
];
/** Yeni anketin dört hazır sorusu (Story 3 kriter 1), sırasıyla. */
export const EVENT_SURVEY_PRESETS = [
    { key: 'overall_satisfaction', kind: 'rating_5' },
    { key: 'recommend', kind: 'nps_10' },
    { key: 'liked_most', kind: 'short_text' },
    { key: 'improve', kind: 'short_text' },
];
export const EVENT_SURVEY_LIMITS = {
    maxQuestions: 10,
    minOptions: 2,
    maxOptions: 8,
    questionTextMax: 200,
    optionTextMax: 80,
    /** Katılımcının kısa metin cevabı (Story 4 kriter 3). */
    answerTextMax: 500,
    /** Belgedeki imza adı ve unvanı (kural 8). */
    signerTextMax: 80,
    /** Katılımcı özetinde tek istekte sorulabilen etkinlik sayısı (geçmiş sayfası 20). */
    statusBatchMax: 50,
    /** Personelin kapatma gerekçesi (zorunlu). */
    disableReasonMin: 10,
    disableReasonMax: 500,
    /**
     * Soru başına sonuç eşiği ve adımı: analitik ve öneri ölçütlerindeki
     * k-anonimlik eşiğinin AYNISI (kural 4, yeni eşik icat edilmez).
     */
    resultStep: BUSINESS_LIMITS.analyticsMinBucketSize,
    /** Anket bitiş + 14 günde kapanır. */
    closeAfterEndDays: 14,
    /** Organizatör en geç bitiş + 7 gün içinde yayınlar. */
    publishWindowDays: 7,
    /** Cevap-kullanıcı bağı kapanıştan 30 gün sonra koparılır. */
    linkRetentionDays: 30,
    /** Serbest metin cevapları etkinlik bitişinden 12 ay sonra silinir. */
    textRetentionMonths: 12,
    /** Puan ve seçim cevapları etkinlik bitişinden 24 ay sonra silinir. */
    scoreRetentionMonths: 24,
};
/** Belge kodunun alfabesi: karışan karakterler (0/O, 1/I/L) yok. */
export const EVENT_CERTIFICATE_CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
export const EVENT_CERTIFICATE_CODE_LENGTH = 12;
/**
 * 5'İN KATI KURALI (kural 4): `answered` cevaptan organizatörün görebileceği
 * kısım. 5'ten az cevapta `0` (eşik altı, sonuç gösterilmez); üstünde en yakın
 * alt 5 katı. 7 cevapta 5, 14 cevapta 10, 15 cevapta 15. Gerekçe: sonuç her
 * cevapta değişseydi "az önce kim cevapladı" bilgisiyle tek kişinin cevabı
 * farktan çıkarılabilirdi.
 */
export function eventSurveyVisibleCount(answered) {
    const step = EVENT_SURVEY_LIMITS.resultStep;
    if (!Number.isFinite(answered) || answered < step)
        return 0;
    return Math.floor(answered / step) * step;
}
/** Anketin kapanış anı: etkinlik bitişi + 14 gün. */
export function eventSurveyClosesAt(endsAt) {
    return new Date(endsAt.getTime() + EVENT_SURVEY_LIMITS.closeAfterEndDays * 86_400_000);
}
/** Yayının son anı: etkinlik bitişi + 7 gün. */
export function eventSurveyPublishDeadline(endsAt) {
    return new Date(endsAt.getTime() + EVENT_SURVEY_LIMITS.publishWindowDays * 86_400_000);
}
/** Belge kodu dört karakterlik gruplarla basılır (`7K2Q-9MXD-…`); kayıt tiresiz tutulur. */
export function formatCertificateCode(code) {
    return code.match(/.{1,4}/g)?.join('-') ?? code;
}
/**
 * Belgedeki tarih aralığı, ETKİNLİĞİN saat diliminde (kural 8): aynı gün tek
 * tarih, çok günlü etkinlikte aralık ("24–25 Ekim 2026"). Geçersiz saat dilimi
 * belgeyi düşürmez, UTC'ye inilir.
 */
export function certificateDateRange(startsAt, endsAt, timezone, localeTag) {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    let format;
    try {
        format = new Intl.DateTimeFormat(localeTag, { ...options, timeZone: timezone });
    }
    catch {
        format = new Intl.DateTimeFormat(localeTag, { ...options, timeZone: 'UTC' });
    }
    const start = format.format(startsAt);
    const end = format.format(endsAt);
    return start === end ? start : format.formatRange(startsAt, endsAt);
}
//# sourceMappingURL=event-survey.js.map